/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Face_Enroll_RegisteredInputs */

const vi_face_enroll_registered = /** @type {(inputs: Face_Enroll_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng ký`)
};

/**

* @param {Face_Enroll_RegisteredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const face_enroll_registered = /** @type {((inputs?: Face_Enroll_RegisteredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Face_Enroll_RegisteredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_face_enroll_registered(inputs)
});